import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { AuthService } from '@data/services/modules/auth/auth.service';

@Directive({
  selector: '[appIfHasPermission]'
})
export class IfHasPermissionDirective implements OnInit {
  @Input('appIfHasPermission') appIfHasPermission!: [string, string] | string | undefined;

  constructor(
    private authService: AuthService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) { }

  ngOnInit() {
    let hasPermission = true; // Por defecto, permitir si no se especifica permiso
    
    if (this.appIfHasPermission) {
      if (Array.isArray(this.appIfHasPermission) && this.appIfHasPermission.length === 2) {
        const [module, permission] = this.appIfHasPermission;
        hasPermission = this.authService.hasModulePermission(module, permission);
      } else if (typeof this.appIfHasPermission === 'string') {
        // Asumir permiso por defecto si es una cadena
        hasPermission = this.authService.hasModulePermission(this.appIfHasPermission, 'view');
      }
    }

    if (hasPermission) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
